import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IServiceAuditorReport,
  IUseServiceAuditReportParams,
  ServiceAuditorDisplayStatus,
} from './types';

const ACTIVE_RUN_REFRESH_INTERVAL_MS = 5000;

export function useServiceAuditReport({
  runId,
  enabled,
}: Readonly<IUseServiceAuditReportParams>) {
  const key =
    enabled && runId
      ? `agent-platform/service-auditor/audits/${encodeURIComponent(runId)}`
      : null;

  // A failed poll keeps the last good report in `data`, so polling continues from the last known status.
  const { data, error, isLoading, mutate } = useSWR<IServiceAuditorReport>(
    key,
    SWRFetcher({ method: 'GET' }),
    {
      refreshInterval: (latest) =>
        latest?.displayStatus === ServiceAuditorDisplayStatus.QUEUED ||
        latest?.displayStatus === ServiceAuditorDisplayStatus.RUNNING
          ? ACTIVE_RUN_REFRESH_INTERVAL_MS
          : 0,
    }
  );

  return {
    report: data ?? null,
    isLoading,
    error,
    mutate,
  };
}
